import React from 'react';
import "./Preloader.css";

function Preloader() {

  return (
    <div className='preloader'>
       <img src="preloader/ripple.svg" alt="preloader"/>
    </div>
  )
}

export default Preloader;